/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-12 20:53:45
 */
export default {
  lang: "英语",
  landing: {
    name1: "Buɗe Carlcare",
    name2: "Yi wata ajiyar wuri",
    name3: "Tare da Carlcare, za ka iya duba odara a kowane lokaci.",
    name4: "",
    name5: "Yi silaid zuwa ga dama ɗin",
    name6: "Tantancewa ta kammala",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for Infinix/Tecno/itel designated models.",
    name11: "Starting from ₱500, you can get your battery replaced with no labor fee.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Flat Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    // name16: "Lower and Transparent Pricing",
    // name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy a 3-month warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. If you join the flat price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.",
    name31: "Carlcare Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Zaɓi samfurin na\'urar",
    name2: "Bayanin Kuskure:",
    name3: "Taɓa don zaɓan shagon sabis",
    name4: "Shagon Sabis",
    name5: "Lokacin Ajiyar Wuri:",
    name6: "Siffanta mana matsalar na\'urarka daki-daki!",
    name7: "Taɓa don zaɓan lokaci isowa",
    name8: "Shigar mana da cikakkun bayananka da ke daidai don mu iya isa gare ka",
    name9: "Lokacin ajiyar wurin da ake samu shi ne kamar haka",
    name10: "Shigar da lambar wayarka mana",
    name11: "Farashi",
    name12: "Bayanin Keɓe:",
    name13: "Shigar da sunanka mana",
    name14: "Gabatar",
    name15: "Soke",
    name16: "YAYI",
  },
  shops: {
    name1: "A dangane da irin wanda ka zaɓa, waɗannan shagunan za su iya maka aiki!",
    name2: "Zai zo nan ba da jimawa a ƙarin kantunan sayar da kaya! Kasance tare da mu!",
  },
  price: {
    name1: "Alama",
    name2: "Tsari",
    name3: "ABU",
    name4: "Farashi",
    name5: "Tunatarwar Abokantaka:",
    name6: "Waɗannan farashin kawai don waiwaye ne kawai kuma ainihin farashin ya danganta ne da yanayin na\'urarka.",
    name7: "Idan babu wata alama ta musamman, sashen farashin shi ne sashen kuɗi na gidan.",
    name8: "Yi haƙuri! Babu bayanin farashi a yankin halin yanzu.",
    name11:"Farashin Leburanci",
    name12:"Jimillar Farashi",
    name13: "5. Idan kuɗin aikin shi ne \"/\", yana nufin cewa da buƙatar a tuntuɓi shagon game da kuɗin aiki.",
    item_main_board: "Babban-allo",
    item_screen_frame: "Allo (Firam)",
    item_screen_screen_frame: "Allo na Biyu (Firam)",
    item_touch_screen: "Taɓa Allo",
    item_camera: "Kamara",
    item_fixed_focus_camera: "An Kafe Mai da Hankalin Kamara",
    item_auto_focus_camera: "Mai da Hankalin Kamara a Atomatik",
    item_screen: "Allo",
    item_secondary_screen: "Allo na Biyu",
    item_fingerprint_module: "Taskar Sawun yatsa",
    item_speaker: "Sifika",
    item_receiver: "Mai karɓa",
    item_small_board: "Ƙaramin Allo",
    item_battery_cover: "Murfin Batiri",
    item_battery: "Batiri",
    item_charger: "Caja",
    item_usb_cable: "Kebur ɗin USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Babu bayanai",
    name2: "Mai Samarwa Sabis:",
    name3: "Alamar Sabis:",
    name4: "Tarho:",
    name5: "Adadin Oda:",
    name6: "Kimar Sabis",
    name7: "Muhallin Sabis",
    name8: "Halin Sabis:",
    name9: "Ingancin Sabis:",
    name10: "Kyaun Sabis:",
    name11: "Kimanta Abokin Ciniki",
    name12:"zuwa",
    name13:"Rufewa",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Buɗe Carlcare",
    name1: "Ɗauki hoton allo mana na bayanin ajiyar wucin-gadi kuma ka adana shi a matsayin rasidi don samun damar sabis ɗin da ke fifiko.",
    name2: "An ci nasarar miƙawa",
    name3: "1. Tsaftace bayanai",
    name4: "Yi tsimin mana bayanai na sirri masu mahimmanci a kan wayar a gaba",
    name5: "2. Naƙasa kalmar-sirri ta kunna wutar",
    name6: "Kafin zuwa shagon sabis ɗin, mana:",
    name7: "Shagon Sabis",
    name8: "Lokacin Ajiyar Wuri:",
    name9: "Bayanin Kuskure:",
    name10: "Samfurin Na\'ura:",
    name11: "Lambar Oda:",
    name12: "Bayanin Oda",
  },
  title: {
   
    name1: "Tana aiki a waɗannan ƙasashe:",
    name2: "Zaɓi Samfur",
    name3: "Ajiyar wuri",
    name4: "Cikakkun Bayanan Shagon Sabis",
    name5: "Zaɓi Shagon Sabis",
  },
  error: {
    
    name1: "Babu bayanai. Duba mana bayaninka na gyara",
    name2: "Kana son ƙarin taimako? Tuntuɓe mu mana.",
    name3: "Yi haƙuri, babu cibiyar Carlcare a cikin yankin halin yanzu.",
    name4: "Zaɓi cibiyar wani sabis da farko mana",
    name5: "Ba a yi nasarar",
    name6: "Zaɓi mana samfurin na\'urar da farko",
    name7: "Cikkaken bayanai",
    name8: "Yi bayanin mana buƙatunka daki-daki",
    name9: "",
  },
  add1:{
    "name0": "ha",
    "name1": "An tabbatar da odarka. Muna sa ido da isowarka.",
    "name2": "Zabi gari",
    "name3": "Saka mana wata lambar waya ta guraben lamba %1$s.",
    "name4": "Sa\\'o\\'in Ranar Mako",
    "name5": "Litinin",
    "name6": "Talata",
    "name7": "Laraba",
    "name8": "Alhamis",
    "name9": "Jumma\\'a",
    "name10": "Asabar",
    "name11": "Lahadi",
    "name12": "Shigar da ƙasa kuma ka bincika"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "Wasu",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Taɓa domin turawa zuwa wani wuri",
    name3:"Buɗe manhajar Carlcare don kimanta odar",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Zaɓi Sabis",
    name7:"Tsaftace Waya",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "Bayani ba daidai ba",
    "cancelReason1": "Ba za a iya isowa a kan lokaci ba",
    "cancelReason2": "Oda ta kwafi/ba odata ba",
    "cancelReason3": "Kasawa ba ta auku ba",
    "cancelReason4": "Kawai don gwaji/tambaya/abin da ya faru/…",
    "cancelReason5": "Babban farashi",
    "cancelReason6": "Ƙarancin kaya",
    "cancelReason7": "Babu bambantattun sabis-sabis",
    "cancelReason8": "Shagon ya yi nisa sosai",
    "cancelReason9": "An rufe shagon",
    "cancelReason10": "Halin sabis maras kyau",
    "cancelReason11": "Musanya/gyara don wasu nau\\'uka",
    "cancelReason12": "Ba za a iya samin shagon ba",
    "cancelReason13": "Saura",
    "cancelOrder": "Soke Oda",
    "reason_dialog_title": "Gaya mana dalili na sokewa mana",
    "Cancel": "Soke",
    "OK": "YA YI",
    "name1": "Enter verification code",
    "name2": "Lambar tabbatarwa ba inganci",
    "repair_reservation_detail_canceled": "An Soke wannan odar!",
    "purchase_cancel_dialog_content": "Shin ka tabbatar da soke odar?",
    "yes": "Eh",
    "no": "A\\'a"
}
};
